import React from 'react'
import './add-instruments-popup.css'

import Axios from 'axios'
import { baseUrl } from '../../assets/Animations'

const AddInstrumentPopup = (props) => {
    const [instArray, setInstArray] = React.useState([])

    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    React.useEffect(() => {
        Axios.get(`${baseUrl}/inst`, myHeader)
        .then((res) => {
            setInstArray(res.data)
        })
        .catch((err) => {
            console.log(err)
        })
    }, [])

    const findAndSetSelectedInstToAddToTeacher = (id) => {
        for(let i = 0; i < instArray.length; i++) {
            if(instArray[i].id === id) {
                props.setListOfInstruments((prev) => [...prev, instArray[i]])
            }
        }
    }

    const findAndDeleteInstrument = (id) => {
        let myInst = props.listOfInstruments
        for(let i = 0; i < myInst.length; i++) {
            if(myInst[i].id === id) {
                myInst.splice(i, 1)
                props.setListOfInstruments([...myInst])
            }
        }
    }

    const tryToClose = (id) => {
        if(id === 'add-instrument-popup-wrapper') {
            props.setInstPopup(false)
        }
    }

    const saveAndClosePopup = () => {
        props.setInstPopup(false)
    }

    return(
        <div className='add-instrument-popup-wrapper' id='add-instrument-popup-wrapper' style={props.studentModal ? {height: '1500px'} : {height: '100%'}} onClick={(e) => tryToClose(e.target.id)}>
            <div className='add-instrument-popup' style={props.studentModal ? {marginTop: '600px'} : {marginTop: '10%'}}>
                <h1>Add Instruments to Teacher</h1>
                {props.listOfInstruments.map((inst) => 
                    <div className='add-inst__inst-list'>
                        <p className='remove-inst-x-inst-popup' onClick={() => findAndDeleteInstrument(inst.id)}>X</p>
                        <p className='add-instrument-popup-instrument'>{inst.name}</p>
                    </div>
                )}
                <div className='inst-dropdown-wrapper'>
                    <select className='inst-dropdown' onChange={(e) => findAndSetSelectedInstToAddToTeacher(e.target.value)} value={{}}>
                        <option value={{}}>Choose Instrument</option>
                        {instArray.length === 0 && <option>loading...</option>}
                        {instArray.map((inst) => <option key={inst.id} value={inst.id}>{inst.name}</option>)}
                    </select>
                </div>
                <div className='add-inst__save-btn__wrapper'>
                    <div className='add-inst__save-btn' onClick={() => saveAndClosePopup()}>Save Instruments</div>
                </div>
            </div>
        </div>
    )
}
export default AddInstrumentPopup;